import { useMutation } from '@tanstack/react-query';
import { googleApiService } from '@/services/GoogleApi.service';
import {
	type LookupResult,
	LookupResultKind
} from '../BusinessConfirmation.types';

export const useBusinessLookupMutation = () =>
	useMutation({
		mutationFn: async (source: string): Promise<LookupResult> => {
			const profile = await googleApiService.findPlaceByQuery(source);
			if (profile) {
				return { kind: LookupResultKind.MAPS, profile };
			}
			return { kind: LookupResultKind.NOTFOUND };
		}
	});
